
window.facet_filters_main_id = 'main-collection-product-overview';
window.facet_filters_sub_id = 'product-grid';

function debounce(fn, wait) {let t;return (...args) => {clearTimeout(t);t = setTimeout(() => fn.apply(this, args), wait);};}

class FiltersForm__SortOrder extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => { this.onSubmitHandler(event); }, 20);
    const sortBySelect = this.querySelector('#sort_by');
    sortBySelect.addEventListener('change', this.debouncedOnSubmit.bind(this));
  }
  createSearchParams(form) {
    const formData = new FormData(form);
    const urlParams = new URLSearchParams(window.location.search); // get existing search params
    const newParams = new URLSearchParams(formData);
    // merge new params with existing ones
    for (const [key, value] of newParams) {
      urlParams.set(key, value);
    }
    return urlParams.toString();
  }
  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.form;
    const searchParams = this.createSearchParams(form);
    if (form.id === 'FacetSortForm') {
      // AJAX load the page when sort_by is changed
      FiltersForm__DropDown.renderPage(searchParams, event, true);
    }
  }
}
customElements.define('filters-form__sortorder', FiltersForm__SortOrder);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onFacetRemoveClick);
  }
  onFacetRemoveClick(event) {
    event.preventDefault();
    const data_url = this.getAttribute('data-url');
    const final_url = data_url.indexOf('?') == -1 ? '' :data_url.slice(data_url.indexOf('?') + 1);
    FiltersForm__DropDown.renderPage(final_url);
  }
}
customElements.define('facet-remove', FacetRemove);

function CheckActiveFiltersMobile() {
  //cl('{A CheckActiveFiltersMobile}');
  if ( window.windoww < 768 ) {
    $('collection-filter-toggle .vertical__accordion details.trigger-open').each(function() {
      var this_id = $(this).attr('id');
      $('#'+this_id+' summary').trigger('click');
    }); 
  }
}

function removeParam(param, searchParams) {
  const params = new URLSearchParams(searchParams);
  params.delete(param);
  return params.toString();
}

class FiltersForm__DropDown extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => { this.onSubmitHandler(event); }, 20);
    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    /*
      const facetWrapper = this.querySelector('#CollectionFilter');
      if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    */
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FiltersForm__DropDown.searchParamsInitial;
      if (searchParams === FiltersForm__DropDown.searchParamsPrev) return;
      FiltersForm__DropDown.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }
  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-filter-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FiltersForm__DropDown.searchParamsPrev = searchParams;
    const sections = FiltersForm__DropDown.getSections();

    //cl('A searchParams: '+ searchParams);
    searchParams = removeParam('filter.v.availability', searchParams);
    searchParams = searchParams + '&filter.v.availability=1';
    //cl('B searchParams: '+ searchParams);

    $('.product-count__text').text('loading');
    $('.product-card-information__title').text('Loading new products');
    $('.price-item--regular').text('Loading');
    if ( window.filter_toggle_version == 'mouse-enter-leave' ) { 
      //CollectionFiltersHideAll('mouse-enter-leave');
    }
    if ( window.filter_toggle_version == 'mouse-click' ) { 
      CollectionFiltersHideAll('mouse-click');
    }
    document.getElementById(window.facet_filters_main_id).classList.add('ajax-content-loading');
    $('.collection-filter__options').addClass('no-pe');
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FiltersForm__DropDown.filterData.some(filterDataUrl) ?
        FiltersForm__DropDown.renderSectionFromCache(filterDataUrl, event) :
        FiltersForm__DropDown.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FiltersForm__DropDown.updateURLHash(searchParams);

  }
  static renderSectionFromFetch(url, event) {
    //cl('{renderSectionFromFetch}');
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FiltersForm__DropDown.filterData = [...FiltersForm__DropDown.filterData, { html, url }];
        FiltersForm__DropDown.renderFilters(html, event);
        FiltersForm__DropDown.renderProductGridContainer(html);
      });
  }
  static renderSectionFromCache(filterDataUrl, event) {
    //cl('{renderSectionFromCache}');
    const html = FiltersForm__DropDown.filterData.find(filterDataUrl).html;
    FiltersForm__DropDown.renderFilters(html, event);
    FiltersForm__DropDown.renderProductGridContainer(html);
  }
  static renderProductGridContainer(html) {
    //cl('{renderProductGridContainer}');
    if ( !isEmpty(document.querySelectorAll(window.facet_filters_main_id)) ) {
      document.getElementById(window.facet_filters_main_id).innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById(window.facet_filters_main_id).innerHTML;
    } else {
      //cl('empty');
    }
    this.AfterAll_TriggerProduct();
  }

  static AfterAll_TriggerProduct() {

    document.getElementById(window.facet_filters_main_id).classList.remove('ajax-content-loading');
    $('.collection-filter__options').removeClass('no-pe');
    if ( document.querySelectorAll("img.js-injectable-svg").length ) { SVGInject(document.querySelectorAll("img.js-injectable-svg")); }
    if ( $('.js-remove-accordion-on-desktop').length ) { CheckDesktopToggleDom(); }
    InitAddToCartButtons();    
    CheckMobileVsDesktop();
    InitSecondProductImage();
    InitMakeLinks();
    InitProductAddCartSubmit();
    InitDetailsHeightToggle();
    //CheckActiveFiltersMobile();

    if ( $('.js-website-use-favorites').val() == 'true' ) { InitAddFavoritesHeart(); }
    $('#CollectionFilter filter-dropdown__details').removeAttr('open');
  }
  static renderFilters(html, event) {
    //cl('{renderFilters}');
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll('#FiltersForm__DropDown .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements);
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
    facetsToRender.forEach((element) => {
      var element_innerHTML = element.innerHTML;
      if ( element_innerHTML != '' && document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`) ) { 
        document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element_innerHTML;
      }
    });
    FiltersForm__DropDown.renderActiveFacets(parsedHTML);
    FiltersForm__DropDown.renderAdditionalElements(parsedHTML);
  }
  static renderActiveFacets(html) {
    //cl('{renderActiveFacets}');

    /*
      const activeFacetElementSelectors = ['.active-facets-desktop'];
      if (window.mobile_enabled === 'enabled') {
        const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
      }
      activeFacetElementSelectors.forEach((selector) => {
        const activeFacetsElement = html.querySelector(selector);
        if (!activeFacetsElement) return;
        const targetElement = document.querySelector(selector);
        if (!targetElement) return;
        targetElement.innerHTML = activeFacetsElement.innerHTML;
      }); 
    */
    
    FiltersForm__DropDown.toggleActiveFacets(false);
  }
  static renderAdditionalElements(html) {
    //cl('{renderAdditionalElements}');
    const ElementSelectors = ['.--collection-sortorder__wrapper', '.js-load-more-wrapper, .collection-filter__active-filters'];
    ElementSelectors.forEach((selector) => {    
      const element = html.querySelector(selector);
      if (!element) return;
      const targetElement = document.querySelector(selector);
      if (!targetElement) return;
      targetElement.innerHTML = element.innerHTML;
    });
    CollectionFiltersOrder();
    CollectionFilterActiveNumber();
  }
  static renderCounts(source, target) {
    const targetElement__Selected = target.querySelector('.collection-filter__selected');
    const sourceElement__Selected= source.querySelector('.collection-filter__selected');
    const targetElement__Header = target.querySelector('.collection-filter__header');
    const sourceElement__Header = source.querySelector('.collection-filter__header');
    const targetElement__Summary = target.querySelector('.filter-dropdown__summary');
    const sourceElement__Summary = source.querySelector('.filter-dropdown__summary');
    const targetElement__Counter = target.querySelector('.facet_product_counter');
    const sourceElement__Counter = source.querySelector('.facet_product_counter');
    if (targetElement__Selected && sourceElement__Selected) { targetElement__Selected.outerHTML = sourceElement__Selected.outerHTML; }
    if (targetElement__Header && sourceElement__Header) { targetElement__Header.outerHTML = sourceElement__Header.outerHTML; }
    if (targetElement__Summary && sourceElement__Summary) { targetElement__Summary.outerHTML = sourceElement__Summary.outerHTML; }
    if (targetElement__Counter && sourceElement__Counter) { targetElement__Counter.outerHTML = sourceElement__Counter.outerHTML; } 
  }
  static updateURLHash(searchParams) {
    //cl('{updateURLHash}');
    //cl(' - searchParams: ' + searchParams );
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [ { section: document.getElementById(window.facet_filters_sub_id).dataset.id } ]
  }
  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }
  onSubmitFilterForm(searchParams, event) {
    FiltersForm__DropDown.renderPage(searchParams, event);
  }
  onSubmitHandler(event) {
    //cl('{onSubmitHandler 3.0}');
    event.preventDefault();    
    const forms = document.querySelectorAll('#FacetSortForm, #FiltersForm__DropDown, #FacetSortDrawerForm');
    const searchParams = [];
    forms.forEach((form) => {
      const noJsElements = document.querySelectorAll('.no-js-list');
      noJsElements.forEach((el) => el.remove());
      searchParams.push(this.createSearchParams(form));
    });
    this.onSubmitFilterForm(searchParams.join('&'), event);
  }
  onActiveFilterClick(event) {
    event.preventDefault();
    FiltersForm__DropDown.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FiltersForm__DropDown.renderPage(url);
  }
}

//CheckActiveFiltersMobile();

FiltersForm__DropDown.filterData = [];
FiltersForm__DropDown.searchParamsInitial = window.location.search.slice(1);
FiltersForm__DropDown.searchParamsPrev = window.location.search.slice(1);
customElements.define('filters-form__dropdown', FiltersForm__DropDown);
FiltersForm__DropDown.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }
  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);

class FilterRemove extends HTMLElement {
  constructor() {
    super();
    if ( this.querySelector('a') ) {
      const filterLink = this.querySelector('a');
      filterLink.setAttribute('role','button');
      filterLink.addEventListener('click', this.closeFilter.bind(this));
      filterLink.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
      });
    }
  }
  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('filters-form__dropdown') || document.querySelector('filters-form__dropdown');
    form.onActiveFilterClick(event);
  }
}
customElements.define('filter-remove', FilterRemove);


function updateUrlParameter(url, parameter, value) {

  //cl('{updateUrlParameter}');
  //cl(' - url: ' + url );
  //cl(' - parameter: ' + parameter );
  //cl(' - value: ' + value );

  const urlParts = url.split('?');
  const query = urlParts[1];
  const params = query ? query.split('&') : [];
  const newParams = [];
  for (let i = 0; i < params.length; i++) {
    const param = params[i].split('=');
    if (param[0] === parameter) {
      newParams.push(`${parameter}=${value}`);
    } else {
      newParams.push(params[i]);
    }
  }
  if (!newParams.length) {
    newParams.push(`${parameter}=${value}`);
  }
  const newQuery = newParams.join('&');
  return `${urlParts[0]}?${newQuery}`;
}

function ClickCollectionLoadMore() {
  "use strict";
  //cl('ClickCollectionLoadMore');
  var $this = $(this), totalPages = parseInt($('.js-total-pages').val()), currentPage = parseInt($('.js-page-number').val());
  var load_more_element = $('.js-load-more-inner');
  load_more_element.attr('disabled', true);
  
  var loading_spinner = '';
  loading_spinner += '<div class="load-more-spinner">';
  loading_spinner += '  <svg class="spinner" viewBox="0 0 60 60">';
  loading_spinner += '    <circle class="path" cx="30" cy="30" r="24" fill="none" stroke-width="5"></circle>';
  loading_spinner += '  </svg>';
  loading_spinner += '</div>';
  
  load_more_element.find('.theme-button span').html('loading');
  load_more_element.find('.theme-button').append(loading_spinner);
  load_more_element.addClass('element-loading');
  var currentNewPage = currentPage + 1;
  var baseUrl = new URLSearchParams(window.location.search); baseUrl.set('page', currentNewPage);
  var nextUrl = `${window.location.pathname}?${baseUrl.toString()}`
  if(currentNewPage > totalPages) { return false; } 
  //history.replaceState(null, null, nextUrl);
  
  $.ajax({ url: nextUrl, type: 'GET', dataType: 'html',
      success: function(responseHTML){
        $('.js-page-number').val(currentNewPage);
        var collection_html  = $(responseHTML).find('.elements__items-list').html();
        $('.elements__items-list').append(collection_html);
      },
      complete: function() {
        if ( document.querySelectorAll("img.js-injectable-svg").length ) { SVGInject(document.querySelectorAll("img.js-injectable-svg")); }
        InitAddToCartButtons();
        CheckMobileVsDesktop();
        InitSecondProductImage(); 
        InitMakeLinks();
        InitProductAddCartSubmit();
        if ( $('.js-website-use-favorites').val() == 'true' ) { InitAddFavoritesHeart(); }

        if( $('.js-load-more-inner').length ) {
          var load_more_element = $('.js-load-more-inner');
          if(currentNewPage < totalPages) { 
            load_more_element.attr('disabled', false);
            load_more_element.removeClass('theme-hidden'); 
            load_more_element.find('a span').text('load more');
            load_more_element.removeClass('triggered');
            load_more_element.removeClass('element-loading');
            ClickCollectionLoadMore__Scroll();
            cl('load more ('+(currentNewPage+1)+'/'+totalPages+')');
          }
          if(currentNewPage >= totalPages) { 
            load_more_element.attr('disabled', true);
            load_more_element.addClass('theme-hidden');
            load_more_element.removeClass('element-loading');
            load_more_element.find('a span').text('end');
          }
        }
      }
  });
}


function setGridSizeCookie(name, value, days) { const expires = new Date(Date.now() + days * 864e5).toUTCString(); document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/'; }
function getGridSizeCookie(name) { return document.cookie.split('; ').reduce((r, v) => { const parts = v.split('='); return parts[0] === name ? decodeURIComponent(parts[1]) : r }, ''); }
class ToggleGridsize extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('div').forEach((element) =>
      element.addEventListener('click', this.ToggleSizeFilter.bind(this))
    );
  }
  connectedCallback() {
    const cookieGridsize = getGridSizeCookie('store-current-gridsize');
    if (cookieGridsize) {
      window.current_gridsize = cookieGridsize;
    } else {
      window.current_gridsize = $('#product-grid').attr('data-gridsize');
    }
    this.updateActiveClass();
    this.SetSizeFilter();
  }
  ToggleSizeFilter(event) {
    event.preventDefault();
    window.current_gridsize = event.currentTarget.getAttribute('data-gridsize');
    setGridSizeCookie('store-current-gridsize', window.current_gridsize, 30);
    this.updateActiveClass();
    this.SetSizeFilter();
  }
  updateActiveClass() {
    this.querySelectorAll('div').forEach(div => div.classList.remove('active'));
    const activeDiv = Array.from(this.querySelectorAll('div')).find(div =>
      div.getAttribute('data-gridsize') === window.current_gridsize
    );
    if (activeDiv) activeDiv.classList.add('active');
  }

  SetSizeFilter() {
    $('#product-grid').attr('data-gridsize', window.current_gridsize);
    cl('{SetSizeFilter} : '+window.current_gridsize);
    if (window.current_gridsize < 4) {
      $('#collection-product-overview .collection').removeClass('theme-page-width');
      $('#collection-product-overview .collection').addClass('theme-page-width__narrow');
    } else {
      $('#collection-product-overview .collection').addClass('theme-page-width');
      $('#collection-product-overview .collection').removeClass('theme-page-width__narrow');
    }
  }
}
customElements.define('filters-form__gridsize', ToggleGridsize);